import { BaseEnum } from "./baseEnum"

const listEnum: Array<HiringStatusType> = [];

export class HiringStatusType extends BaseEnum {
  static Expired = new HiringStatusType(-1, 'Expired', 'Expirado', 'danger');
  static PreRegistration = new HiringStatusType(0, 'PreRegistration', 'Pré Cadastro', 'info');
  static WaitingSesmt = new HiringStatusType(1, 'WaitingSesmt', 'Aguardando Sesmt', 'secondary');

  static WaitingPreliminaryCourse = new HiringStatusType(100, 'WaitingPreliminaryCourse', 'Aguardando Curso Preliminar', 'secondary');
  static AprovedPreliminaryCourse = new HiringStatusType(101, 'AprovedPreliminaryCourse', 'Aprovado Curso Preliminar', 'primary');
  static ReprovedPreliminaryCourse = new HiringStatusType(102, 'ReprovedPreliminaryCourse', 'Reprovado Curso Preliminar', 'danger');

  static WaitingApplicant = new HiringStatusType(2, 'WaitingApplicant', 'Aguardando Candidato', 'info');
  static WaitingDP = new HiringStatusType(3, 'WaitingDP', 'Aguardando DP', 'warning');
  static InvalidDocs = new HiringStatusType(4, 'InvalidDocs', 'Reenvio de documentos', 'danger');
  static Finished = new HiringStatusType(5, 'Finished', 'Finalizado', 'success');
  static Integrated = new HiringStatusType(6, 'Integrated', 'Integrado', 'primary');
  static AwaitingOfferLetter = new HiringStatusType(7, 'AwaitingOfferLetter', 'Aguardando Carta Oferta', 'secondary');
  static AwaitingOfferLetterAcceptance = new HiringStatusType(8, 'AwaitingOfferLetterAcceptance', 'Aguardando Aceite da Carta', 'secondary');
  static OfferLetterDeclined = new HiringStatusType(9, 'OfferLetterDeclined', 'Carta de Oferta Recusada', 'danger');
  static Withdrawal = new HiringStatusType(10, 'Withdrawal', 'Desistência', 'warning');

  static Concluded = new HiringStatusType(11, 'Concluded', 'Finalizado - Docs Enviados', 'success');

  constructor(public id: number, public value: string, public label: string, public className: string) {
    super(id, value, label, className)
    listEnum.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listEnum;
  }

  public static findByValue(value: string): HiringStatusType | undefined {
    return listEnum.find((status) => status.value === value) as HiringStatusType;
  }

  public static getPreliminaryCourseStatuses(): HiringStatusType[] {
    return [
      HiringStatusType.WaitingPreliminaryCourse,
      // HiringStatusType.AprovedPreliminaryCourse,
      HiringStatusType.ReprovedPreliminaryCourse,
    ];
  }

  public static getOfferLetterStatuses(): HiringStatusType[] {
    return [
      HiringStatusType.AwaitingOfferLetter,
      HiringStatusType.AwaitingOfferLetterAcceptance,
      HiringStatusType.OfferLetterDeclined,
    ];
  }

  public static getPostAdmissionStatuses(): HiringStatusType[] {
    return [
      HiringStatusType.Concluded,
    ];
  }

  public static getDefaultStatuses(): HiringStatusType[] {
    return this.buildListEnum().filter(
      s => !this.getPreliminaryCourseStatuses().includes(s) 
      && !this.getOfferLetterStatuses().includes(s)
      && !this.getPostAdmissionStatuses().includes(s)
    );
  }
}